import store from '@/store';

export default class ChatPauseEvent {
  constructor(body) {
    window.console.log(
      '%c [event]',
      'color: #F44336;',
      JSON.stringify(body, null, 4),
    );
    store.dispatch('pause/enterPauseChat', body.body.reason);
  }
}
